export default __webpack_public_path__ + "static/media/bootstrap.css.be542b43.map";